import { CompanyDeletionComponent } from './company-deletion.component';

export { CompanyDeletionComponent };
